module.exports = __webpack_public_path__ + "assets/img/white-cropped.856ff3b3.jpg";